import { apiClient } from '@/api/client';
import type {
  AssignmentDisciplineParams,
  AssignmentDisciplineSummary,
} from '@/types/discipline';

function buildParams(p: AssignmentDisciplineParams): URLSearchParams {
  const q = new URLSearchParams();
  q.set('courseId', String(p.courseId));
  if (p.teamIds && p.teamIds.length > 0) {
    // Backend accepts repeated `teamId` query params (mirrors private API).
    for (const id of p.teamIds) q.append('teamId', String(id));
  }
  if (p.assignmentId !== undefined && p.assignmentId !== null) {
    q.set('assignmentId', String(p.assignmentId));
  }
  if (p.type) q.set('type', p.type);
  return q;
}

/**
 * Fetch the discipline report for one course (+ optional team filter).
 * Returns the same shape as the private endpoint
 * `/private/assignment-submission-reports`:
 * - With teamIds: List<AssignmentSubmissionSummaryResponse> (per-team rows)
 * - Without teamIds: List<AssignmentGroupedResponse> (aggregated across teams)
 *
 * The admin page always passes teamIds (required by the UX) so this signature
 * declares the team-scoped shape directly.
 */
export async function listAssignmentDisciplineReports(
  params: AssignmentDisciplineParams,
): Promise<AssignmentDisciplineSummary[]> {
  const { data } = await apiClient.get<AssignmentDisciplineSummary[]>(
    `/admin/discipline/assignment-reports`,
    { params: buildParams(params) },
  );
  return data;
}
